import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { AlertCircle, CheckCircle } from 'lucide-react';

export const SummaryCard = ({ title, results, category }: { title: string; results: any; category: 'lint' | 'typecheck' | 'tests' }) => {
  const data = results?.[category];
  const passed = data?.passed || 0;
  const failed = data?.failed || 0;

  if (!data) {
    return (
        <Card>
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                <CardTitle className="text-sm font-medium">{title}</CardTitle>
            </CardHeader>
            <CardContent>
                <div className="text-2xl font-bold">N/A</div>
                <p className="text-xs text-muted-foreground">Not run</p>
            </CardContent>
        </Card>
    );
  }

  return (
    <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">{title}</CardTitle>
            {failed > 0 ? <AlertCircle className="h-4 w-4 text-destructive" /> : (passed > 0 || (data && failed === 0)) && <CheckCircle className="h-4 w-4 text-green-500" />}
        </CardHeader>
        <CardContent>
            <div className="text-2xl font-bold">{passed} <span className="text-lg font-normal text-muted-foreground">Passed</span></div>
            <div className="flex space-x-2 text-xs text-muted-foreground">
                {failed > 0 && <span className="text-destructive">{failed} failed</span>}
            </div>
        </CardContent>
    </Card>
  )
};